/**
 * Default branch names to auto-select, in priority order
 */
export const DEFAULT_BRANCH_NAMES = [
  'main',
  'master',
  'development',
  'develop',
  'dev'
];

/**
 * Auto-select the best matching branch from available branches
 * @param {string[]} branchNames - Available branch names
 * @returns {string|null} - Selected branch name or null
 */
export const selectDefaultBranch = (branchNames) => {
  if (!branchNames || branchNames.length === 0) return null;
  
  const lowerNames = branchNames.map(name => name.toLowerCase());
  
  for (const defaultName of DEFAULT_BRANCH_NAMES) {
    const index = lowerNames.indexOf(defaultName);
    if (index > -1) return branchNames[index];
  }
  
  return branchNames[0];
};
